import React from "react";
import { Box, FormControl, FormErrorMessage, FormLabel, Text } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { styles } from "../../ReactSelectStyles";
import { COLORS } from "../../../../Helper/Colors";

export const DropDown = ({ label, size, error, errorMsg, isRequired, ...rest }) => {
	return (
		<FormControl flex={1} isInvalid={error}>
			<Box display={"flex"} flexDirection='row' alignItems={isRequired ? "start" : "center"}>
				<FormLabel htmlFor={rest.name} textTransform={"capitalize"} marginRight={0}>
					{label}
				</FormLabel>
				{!!isRequired && (
					<Text alignItems={"start"} marginLeft={1} color={COLORS.red}>
						*
					</Text>
				)}
			</Box>
			<Select
				chakraStyles={styles}
				className='custom-input'
				colorScheme={COLORS.brand}
				size={size ? size : "lg"}
				selectedOptionColor={"brand"}
				{...rest}
			/>
			{!!error && <FormErrorMessage>{errorMsg}</FormErrorMessage>}
		</FormControl>
	);
};
